'use strict';

/** @type {import('./max')} */
module.exports = Math.max;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/math-intrinsics@1.1.0/~/math-intrinsics/max.js
// module id = 753
// module chunks = 0